module.exports = __webpack_public_path__ + "images/rdr2-b_rgba(0,0,0,0.7).bee6c096d26f499d0af9fbc7f64cb40e.jpg";